import React ,{Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, change ,reset} from 'redux-form';

//Material ui components
import {Button,Grid,} from '@material-ui/core'
import Popover from '@material-ui/core/Popover';
import Slide from '@material-ui/core/Slide';

//engage Components
import {
    SimpleSelect
} from '../../utils/engageComponents';

const validate = (values) => {
  };


export class ResidentsFiltersDrawer extends Component{
    constructor(props){
        super();
        this.state={
            //filterObj
            filterObj: undefined,

            //NameFilter
            openNameFilterSelect: false,
            NameSelected: undefined,

            //LastNameFilter
            openLastNameFilterSelect: false,
            LastNameSelected:undefined,

            //ZoneFilter
            openZoneNameFilterSelect: false,
            ZoneNameSelected:undefined,
        }    

        props.dispatch(change('ResidentFiltersForm','FiltersName', ''));
        props.dispatch(change('ResidentFiltersForm','FiltersLastName', ''));
        props.dispatch(change('ResidentFiltersForm','FiltersZoneName', ''));

    };

    componentDidMount = ()=>{
        window.addEventListener('resize', this.resize);

        if(this.props){

            if(this.props.idAnchorEl){
                this.setAnchorEl(this.props.idAnchorEl);
            }            
        }
      

    };

    componentWillUnmount= () =>{
        window.removeEventListener('resize', this.resize);
    };

    resize = ()=> {
        if(this.props && this.props.idAnchorEl){
            this.setAnchorEl(this.props.idAnchorEl)
        }           
    };

    setAnchorEl(idAnchorEl){

        const anchorEl = document.getElementById(idAnchorEl);

        if(anchorEl){
            this.setState({anchorEl: anchorEl})
        }
    };

    renderFilters(filterObj){

        let nameSelected = undefined;
        let lastNameSelected = undefined;
        let zoneNameSelected =undefined;

        if(filterObj.nameFilter){
            nameSelected = this.props.names.find(item => item === filterObj.nameFilter);
        }
        if(filterObj.lastNameFilter){
            lastNameSelected = this.props.lastNames.find(item => item === filterObj.lastNameFilter);
        }
        if(filterObj.zoneNameFilter){
            zoneNameSelected = this.props.zoneNames.find(item => item === filterObj.zoneNameFilter);
        }

        this.props.dispatch(change('ResidentFiltersForm','FiltersName', nameSelected));
        this.props.dispatch(change('ResidentFiltersForm','FiltersLastName', lastNameSelected));
        this.props.dispatch(change('ResidentFiltersForm','FiltersZoneName', zoneNameSelected));
        
        this.setState({
            NameSelected: {name: nameSelected},
            LastNameSelected: {name: lastNameSelected},
            ZoneNameSelected:{name: zoneNameSelected}
        });
    };

     //#region INNER COMPONENTS
     FiltersConponent = () =>{
        const styles={
            container:{
                position:'relative'
            },
            filterContainer:{
                marginTop:'35px',
                borderRadius:'15px',
                border:'1px solid white',

            },
            spaceFillerContainer:{
                height:'100px'
            },
            resetFiltersContainer:{
                padding:'25px 10px',
            }
        }

        return(
            <Grid item container className='popOverFilterContainer' style={{...styles.container}}>
                <Grid item container>
                    <this.TitleComponent/>
                </Grid>
                <Grid item container style={{...styles.filterContainer}}>
                    <this.NameFiltersComponent/>
                </Grid>
                <Grid item container style={{...styles.filterContainer}}>
                    <this.LastNamesFilterComponent/>
                </Grid>
                <Grid item container style={{...styles.filterContainer}}>
                    <this.ZoneNamesFilterComponent/>
                </Grid>
                {/* <Grid item container style={{...styles.spaceFillerContainer}}>
                </Grid> */}
                {/* <Grid item style={{...styles.resetFiltersContainer}}>
                    <this.ResetFiltersComponent/>
                </Grid> */}
                <Grid item container style={{...styles.resetFiltersContainer}}>
                    <this.FiltersButtons/>
                </Grid>
            </Grid>
        );
    };

    FiltersButtons = () => {
        return(
        <Grid item container xs={12}>
            {/* Apply filters buttons */}
                <Button className="filters_btn" onClick={() => this.props.applyFilters()}>Apply Current Filters</Button>
                <Button className='filters_clear_btn' onClick={() => this.props.resetFilters()}>Clear All</Button>
        </Grid>
        )
    }

    TitleComponent= () => {
        return(
        <Grid item container>
            <Grid item className='popOverFiltersTitle'>Filters</Grid>
        </Grid>);
    };

    NameFiltersComponent = () =>{

        //This 3 const are for eliminate the duplicate elements in names 
        const names = this.props.names?[...this.props.names]:[] 

        const namesFiltered = [...new Set(names)] 
   
        const namesArr = namesFiltered.map(item=>({name:item}))

        const nameSelected = this.state.NameSelected? this.state.NameSelected: {}; 
        return(
            <Grid item  
            xs={12} 
            style={{paddingLeft:'15px', marginRight:'15px'}} 
            justify='center'
            onBlur={() => {this.setState({openNameFilterSelect: false});}}
            onClick={() => {this.setState ((prevState) =>({openNameFilterSelect: !prevState.openNameFilterSelect}));} } >
                 <SimpleSelect
                    idToSet='resident_filters_first_name'
                    showLabel={true}
                    label={'First Name'}
                    open={this.state.openNameFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedName(newItem)}
                    optionsItemsIconsData = {namesArr}
                    selected={nameSelected}
                    disabled= { false}
                    error={ undefined}
                    helperText = { undefined}
                    autoFocus={true}
                    stylesObj={{underline:'noBorderStyle'}}
                />
            </Grid>
            );
    };

    LastNamesFilterComponent = () =>{
          //This 3 const are for eliminate the duplicate items of last names 
        const lastNames = this.props.lastNames?[...this.props.lastNames]:[];
        const lastNamesFiltered = [...new Set(lastNames)];  
        const lastNamesArr = lastNamesFiltered.map(item=>({name:item}));
        const lastNameSelected = this.state.LastNameSelected? this.state.LastNameSelected : {};

        return(
            <Grid item  
                xs={12} 
                style={{paddingLeft:'15px', marginRight:'15px'}} 
                justify='center' 
                onBlur={() => this.setState({openLastNameFilterSelect: false})}
                onClick={() => this.setState ((prevState) =>({openLastNameFilterSelect: !prevState.openLastNameFilterSelect}))}
            >
                <SimpleSelect
                    idToSet='resident_filters_last_name'
                    showLabel={true}
                    label={'Last Name'}
                    open={this.state.openLastNameFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedLastName(newItem)}
                    optionsItemsIconsData = {lastNamesArr}
                    selected={lastNameSelected}
                    disabled= { false}
                    error={ undefined}
                    helperText = { undefined}
                    autoFocus={true}
                    stylesObj={{underline:'noBorderStyle'}}
                />
            </Grid>
        );
    };
    
    ZoneNamesFilterComponent = () =>{

        //This 3 const are for eliminate the duplicate items of zones 
        const zones = this.props.zoneNames?[...this.props.zoneNames]:[] 

        const zonesFiltered = [...new Set(zones)] 

        const locations = zonesFiltered.map(item=>({name:item}))

        const zoneNameSelected = this.state.ZoneNameSelected? this.state.ZoneNameSelected : {};

        return(
            <Grid item  
                xs={12} 
                style={{paddingLeft:'15px', marginRight:'15px'}} 
                justify='center' 
                onBlur={() => this.setState({openZoneNameFilterSelect: false})}
                onClick={() => this.setState ((prevState) =>({openZoneNameFilterSelect: !prevState.openZoneNameFilterSelect}))}
            >
                <SimpleSelect
                    idToSet='resident_filters_location'
                    showLabel={true}
                    label={'Location'}
                    open={this.state.openZoneNameFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedZoneName(newItem)}
                    optionsItemsIconsData = {locations}
                    selected={zoneNameSelected}
                    disabled= { false}
                    error={ undefined}
                    helperText = { undefined}
                    autoFocus={true}
                    stylesObj={{underline:'noBorderStyle'}}
                />
            </Grid>
        );
    };

    ResetFiltersComponent = () =>{
        const handleSubmit = this.props.handleSubmit;
        return(
            <Button id='resident_filters_reset_btn' className='appbtn-engage skybluebtn-engage appbtnBarButton textTransform' onClick={handleSubmit(this.onSubmitHandler.bind(this))}>Reset</Button>
        );
    }
    //#endregion
    
   
    //region Handlers
    handlerChangeOptionSelectedName=(newFilterName)=>{
        this.setState({ NameSelected: newFilterName},
            () =>{
                if(newFilterName){
                    const oldFilterObj = this.props.filterObj? this.state.filterObj : {};

                    const newFilterObj ={...oldFilterObj , nameFilter: newFilterName.name}
                    this.props.onFilterChange(newFilterObj)
                }
            }
        )       
    }
    handlerChangeOptionSelectedLastName=(newFilterLastName)=>{
        this.setState({ LastNameSelected: newFilterLastName},
            () =>{
                if(newFilterLastName){
                    const oldFilterObj = this.props.filterObj? this.state.filterObj : {};

                    const newFilterObj ={...oldFilterObj , lastNameFilter: newFilterLastName.name}

                    this.props.onFilterChange(newFilterObj)
                }
            }
        )       
    }
    handlerChangeOptionSelectedZoneName=(newFilterZoneName)=>{
        this.setState({ ZoneNameSelected: newFilterZoneName},
            () =>{
                if(newFilterZoneName){
                    const oldFilterObj = this.props.filterObj? this.state.filterObj : {};

                    const newFilterObj ={...oldFilterObj , zoneNameFilter: newFilterZoneName.name}

                    this.props.onFilterChange(newFilterObj)
                }
            }
        )       

    }
    
    handlerCleanFilters = () =>{
        const newFilterObj = this.props.filterObj? {...this.props.filterObj} : {};

        delete newFilterObj.nameFilter;
        delete newFilterObj.lastNameFilter;
        delete newFilterObj.zoneNameFilter;

        this.props.onFilterChange(newFilterObj);

        this.setState({
            //filterObj
            filterObj: undefined,

           //NameFilter
           openNameFilterSelect: false,
           NameSelected: undefined,


           //LastNameFilter
           openLastNameFilterSelect: false,
           LastNameSelected:undefined,

           //ZoneFilter
           openZoneNameFilterSelect: false,
           ZoneNameSelected:undefined,
        });        
        
        this.props.dispatch(reset('ResidentFiltersForm'));
        this.props.dispatch(change('ResidentFiltersForm','FiltersName', ''));
        this.props.dispatch(change('ResidentFiltersForm','FiltersLastName', ''));
        this.props.dispatch(change('ResidentFiltersForm','FiltersZoneName', ''));

   }
    onSubmitHandler = (form) => {
        this.handlerCleanFilters();
    }

    //#endregion

    render(){

        if(this.props.filterObj !== this.state.filterObj){
            this.setState({filterObj: this.props.filterObj? this.props.filterObj : {}}, () =>{
                this.renderFilters(this.props.filterObj);
            })            
        }


        return(
            <>
            {
                this.state.anchorEl?
                    <Popover
                        id="ResidentFiltersPopOvere"
                        open={true}
                        onClose={this.props.onClose}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        
                        PaperProps={{
                            className:'popOverFilter',
                        }}
                        elevation={0}
                    >
                        <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                            <Grid  className='popOverFilterSlide' style={{height:'100%'}}>
                                <form>
                                    <this.FiltersConponent/>
                                   
                                </form>
                            </Grid>
                        </Slide>
                    </Popover>
                :
                undefined
            }
            </>
            )
    }
}


function mapStateToProps(state){  
    
    return{ };
};

export default connect(mapStateToProps, {})(reduxForm({
    form: 'ResidentFiltersForm',
    validate,
})(ResidentsFiltersDrawer));